import React from 'react';
import { 
    Box, 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem, 
    Typography 
} from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';

/**
 * ContentBucketSelector Component
 * Handles content bucket selection for post organization
 * Following PostDetailsModal.js clean structure patterns
 */
const ContentBucketSelector = ({
    selectedBucket,
    onBucketChange,
    buckets,
    disabled = false
}) => {
    if (!buckets || buckets.length === 0) {
        return null;
    }

    const activeBuckets = buckets.filter(bucket => bucket.is_active);

    if (activeBuckets.length === 0) {
        return null;
    }

    return (
        <Box sx={{ mb: 3 }}>
            <FormControl fullWidth variant="outlined" disabled={disabled}>
                <InputLabel id="bucket-select-label">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FolderIcon fontSize="small" />
                        Content Bucket (Optional)
                    </Box>
                </InputLabel>
                <Select
                    labelId="bucket-select-label"
                    value={selectedBucket}
                    onChange={(e) => onBucketChange(e.target.value)}
                    label="Content Bucket (Optional)"
                    sx={{
                        '& .MuiSelect-select': {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }
                    }}
                >
                    <MenuItem value="">
                        <em>No bucket selected</em>
                    </MenuItem>
                    {activeBuckets.map((bucket) => (
                        <MenuItem key={bucket.id} value={bucket.id}>
                            <Box sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: 1, 
                                width: '100%' 
                            }}>
                                <Box
                                    sx={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: '50%',
                                        backgroundColor: bucket.color || '#2196f3',
                                        flexShrink: 0
                                    }}
                                />
                                <Typography variant="body1" sx={{ flex: 1 }}>
                                    {bucket.name}
                                </Typography>
                                {bucket.industry_template && (
                                    <Typography variant="caption" color="text.secondary">
                                        {bucket.industry_template
                                            .replace('_', ' ')
                                            .replace(/\b\w/g, l => l.toUpperCase())
                                        }
                                    </Typography>
                                )}
                            </Box>
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default ContentBucketSelector; 